import { Helmet } from "react-helmet-async";
import TabsMAIQ from "app/components/TabsMAIQ";
import RolesTab from "./components/role/RolesTab";
import ScopesTab from "./components/scope/ScopesTab";
import ResourcesTab from "./components/resource/ResourcesTab";
import { PageContainer, PageHeader } from "app/components/StyledComponents";
import { BreadcrumbsComponent } from "app/components/BreadcrumbsComponent";
import LoadingIndicator from "app/components/LoadingIndicator";

const RoleManagementPage = () => {
  const tabsData = [
    { label: "ROLES", content: <RolesTab /> },
    { label: "SCOPES", content: <ScopesTab /> },
    { label: "RESOURCES", content: <ResourcesTab /> },
  ];

  const breadcrumbsList = [
    { label: "Role Management", isActive: true }
  ];

  return (
    <>
      <Helmet>
        <title>Role Management</title>
        <meta name="description" content="Manage Roles, Scopes, and Resources Information" />
      </Helmet>
      <PageContainer>
        <BreadcrumbsComponent breadcrumbsList={breadcrumbsList} />
        <PageHeader>Role Management</PageHeader>
        <TabsMAIQ tabs={tabsData} />
      </PageContainer>
    </>
  );
};

export default RoleManagementPage; 